import CripNotice from "crip-vue-notice";
import { HelperNetworkCallBack } from "../mixins/Helper";
import { serverAddr } from "../networkConfig";

export var loginNetworkCallBack = {
  mixins: [HelperNetworkCallBack],

  methods: {
    loginUserNetworkCallBack(response) {
      if (response.data.status) {
        this.is_login_btn_loading = false; //disable login btn loader
        let body = document.getElementsByTagName("body")[0];
        body.style.overflow = "auto";

        if (response.data.profile_data) {
          let roles = response.data.profile_data.user_data.roles;
          let user_id = response.data.profile_data.user_data.user_id;
          let subscribed_plan_detail = response.data.sub_plan_data
            ? response.data.sub_plan_data
            : {};
          let publisher_plan_detail = response.data.publisher_plan_data
            ? response.data.publisher_plan_data
            : {};
          let profile = JSON.parse(
            JSON.stringify(response.data.profile_data.profile_data)
          );
          profile.username = this.username;
          profile.last_seen = response.data.profile_data.last_seen;
          profile.reco_count = response.data.count;
          // if (response.data.profile_data.profile_data.utm_medium == "EMAIL") {
          profile.ask_password_for_change =
            response.data.ask_password_for_change;
          // }

          // save navigation to localStorage
          // if (response.data.navigation) {
          //   profile.navigation = Object.keys(response.data.navigation).length
          //     ? response.data.navigation
          //     : "";
          // }

          this.saveRolesToLocalStorage(roles);
          this.saveProfileToLocalStorage(profile);
          this.saveUserIdToLocalStorage(user_id);
          this.saveSubscribedPlanDetailsToLocalStorage(subscribed_plan_detail);
          this.saveSubscribedPublisherPlanDetails(publisher_plan_detail);

          //if fcm token is available then called fcm api
          if (
            localStorage.getItem("fcm_token") &&
            !localStorage.getItem("isWelcomeNotificationTokenSent") &&
            user_id
          ) {
            this.sendFcmTokenToServer(user_id);
          }
          this.selectUserType();

          this.$root.$emit("updatedProfileData");
        }

        // remove UserType on basis of landing page
        if (localStorage.getItem("UserType")) {
          localStorage.removeItem("UserType");
        }

        this.show_error_on_empty = false;
        this.username = "";
        this.password = "";

        new CripNotice({
          title: "Success",
          description: "Welcome to StockAnts",
          type: "success",
          duration: 1.5,
        });

        // Make eKYC compulsary and redirect user to profile if eKYC not done
        if (response.data.ask_password_for_change) {
          this.$router.push("/change-password");
        } else if (
          response.data.profile_data.profile_data &&
          response.data.profile_data.profile_data.profession !=
            "Retail Investor"
        ) {
          if (
            !response.data.profile_data.profile_data.full_name &&
            !response.data.profile_data.profile_data.first_name &&
            !response.data.profile_data.profile_data.last_name
          ) {
            this.$router.push({
              name: "profileUpdate",
              params: {
                active_step: 1,
              },
            });
          } else if (
            response.data.profile_data.profile_data.profession == "Analyst" ||
            response.data.profile_data.profile_data.profession ==
              "Financial Advisor" ||
            response.data.profile_data.profile_data.profession == "Broker"
          ) {
            if (
              !response.data.profile_data.profile_data.aadhar_card_status ||
              !response.data.profile_data.profile_data.pan_card_status ||
              !response.data.profile_data.profile_data.sebi_certificate_status
            ) {
              setTimeout(() => {
                new CripNotice({
                  title: "Info",
                  description: "Please fill the ekyc details",
                  type: "info",
                  duration: 3,
                });
              }, 3000);
              this.$router.push({
                name: "profileUpdate",
                params: {
                  active_step: 2,
                },
              });
            } else {
              this.$router.push(response.data.redirect);
            }
          } else {
            this.$router.push(response.data.redirect);
          }
        } else {
          this.$router.push(response.data.redirect);
        }

        //if fcm token is available then called fcm api
        if (
          localStorage.getItem("fcm_token") &&
          !localStorage.getItem("isWelcomeNotificationTokenSent")
        ) {
          this.sendFcmTokenToServer();
        }

      } else {
        this.is_login_btn_loading = false; //disable login btn loader
        this.isLoading = false;
        this.show_error_on_empty = false;
        this.password = "";
        this.verifyPin = "";
      }
    },

    sendFcmTokenToServer(user_id) {
      if (user_id && localStorage.getItem("fcm_token")) {
        serverAddr
          .post("/config/fcm-view/", {
            user: user_id,
            type: "web",
            registration_id: localStorage.getItem("fcm_token"),
          })
          .then((response) => {
            if (response.data.status) {
              console.log("sending welcome notification...");
              localStorage.setItem("isWelcomeNotificationTokenSent", true);
            } else {
              localStorage.setItem("isWelcomeNotificationTokenSent", false);
            }
          })
          .catch(
            function(error) {
              console.log(error);
              localStorage.setItem("isWelcomeNotificationTokenSent", false);
            }.bind(this)
          );
      }
    },

    socialLoginUserNetworkCallBack(response, email) {
      if (response.data.status) {
        let body = document.getElementsByTagName("body")[0];
        body.style.overflow = "auto";

        let roles = response.data.profile_data.user_data.roles;
        let user_id = response.data.profile_data.user_data.user_id;
        let subscribed_plan_detail = response.data.sub_plan_data
          ? response.data.sub_plan_data
          : {};

        let publisher_plan_detail = response.data.publisher_plan_data
          ? response.data.publisher_plan_data
          : {};
        let profile = response.data.profile_data.profile_data;
        profile.username = email ? email : this.username;
        profile.last_seen = response.data.profile_data.last_seen;
        profile.reco_count = response.data.count;

        // // save navigation to localStorage
        // if (response.data.navigation) {
        //   profile.navigation = Object.keys(response.data.navigation).length
        //     ? response.data.navigation
        //     : "";
        // }

        this.saveRolesToLocalStorage(roles);
        this.saveProfileToLocalStorage(profile);
        this.saveUserIdToLocalStorage(user_id);
        this.saveSubscribedPlanDetailsToLocalStorage(subscribed_plan_detail);
        this.saveSubscribedPublisherPlanDetails(publisher_plan_detail);

        // if(response.data.token_data){
        //     localStorage.setItem('token', response.data.token_data.access_token);
        // }

        //if fcm token is available then called fcm api
        if (
          localStorage.getItem("fcm_token") &&
          !localStorage.getItem("isWelcomeNotificationTokenSent") &&
          user_id
        ) {
          this.sendFcmTokenToServer(user_id);
        }

        this.selectUserType();

        this.$root.$emit("updatedProfileData");

        this.show_error_on_empty = false;
        this.username = "";
        this.password = "";
        this.referal_code = "";

        new CripNotice({
          title: "Success",
          description: "Welcome to StockAnts",
          type: "success",
          duration: 1.5,
        });

        let route_name = localStorage.getItem("route_to_be");

        if (route_name && response.data.redirect != "/profile-update") {
          this.$router.push(route_name);
        } else if (
          response.data.profile_data.profile_data &&
          (response.data.profile_data.profile_data.profession == "Analyst" ||
            response.data.profile_data.profile_data.profession ==
              "Financial Advisor" ||
            response.data.profile_data.profile_data.profession == "Broker")
        ) {
          if (
            !response.data.profile_data.profile_data.aadhar_card_status ||
            !response.data.profile_data.profile_data.pan_card_status ||
            !response.data.profile_data.profile_data.sebi_certificate_status
          ) {
            this.$router.push({
              name: "profileUpdate",
              params: {
                active_step: 2,
              },
            });
            setTimeout(() => {
              new CripNotice({
                title: "Info",
                description: "Please fill the ekyc details",
                type: "info",
                duration: 3,
              });
            }, 3000);
          } else {
            this.$router.push(response.data.redirect);
          }
        } else {
          this.$router.push(response.data.redirect);
        }

        localStorage.removeItem("route_to_be");

        // remove UserType on basis of landing page
        if (localStorage.getItem("UserType")) {
          localStorage.removeItem("UserType");
        }
      } else {
        this.show_error_on_empty = false;
        this.password = "";
      }
    },

    createUserNetworkCallBack(response) {
      if (response.data.status) {
        this.is_sign_up_btn_loading = false; //disable signup btn loader
        let user_id = response.data.user_id;
        this.saveUserIdToLocalStorage(user_id);

        let body = document.getElementsByTagName("body")[0];
        body.style.overflow = "auto";

        let profile = {};
        profile.username = this.username;

        localStorage.setItem("auth_email", this.username); //to validate email on otp verification page

        // this.saveProfileToLocalStorage(profile);
        this.show_error_on_empty = false;
        this.username = "";
        this.password = "";
        // this.confirm_password = "";
        this.referal_code = "";
        this.$router.push(response.data.redirect);

        new CripNotice({
          title: "Success",
          description: response.data.validation,
          type: "success",
          duration: 3,
        });

        if (
          localStorage.getItem("fcm_token") &&
          !localStorage.getItem("isWelcomeNotificationTokenSent") &&
          user_id
        ) {
          this.sendFcmTokenToServer(user_id);
        }
      } else {
        this.is_sign_up_btn_loading = false; //disable signup btn loading
        this.show_error_on_empty = false;
        this.password = "";
        // this.confirm_password = "";
        this.referal_code = "";
        this.sign_up_form = false;
        this.sign_in_form = true;
      }
    },

    //verify otp callback after sign up
    verifyOtpNetworkCallBack(response) {
      if (response.data.status) {
        this.is_vefiry_otp_btn_loading = false; //disable verify otp btn loader
        let body = document.getElementsByTagName("body")[0];
        body.style.overflow = "auto";

        if (response.data.profile_data) {
          let profile = response.data.profile_data.profile_data;
          let user_id = response.data.profile_data.user_data.user_id;

          // if (window.location.href.includes("http://localhost:8080/")) {
          //   profile.is_user_verified_with_signzy = true;
          //   profile.aadhar_card_number = "447151288736";
          //   profile.pan_card_number = "ABCDEF234D";
          //   profile.aadhar_card_status = "UPLOADED";
          //   profile.pan_card_status = "UPLOADED";
          // }

          this.saveUserIdToLocalStorage(user_id);
          this.saveProfileToLocalStorage(profile);

          if (
            localStorage.getItem("fcm_token") &&
            !localStorage.getItem("isWelcomeNotificationTokenSent") &&
            user_id
          ) {
            this.sendFcmTokenToServer(user_id);
          }
        }

        let subscribed_plan_detail = response.data.sub_plan_data
          ? response.data.sub_plan_data
          : {};

        let publisher_plan_detail = response.data.publisher_plan_data
          ? response.data.publisher_plan_data
          : {};

        this.saveSubscribedPlanDetailsToLocalStorage(subscribed_plan_detail);
        this.saveSubscribedPublisherPlanDetails(publisher_plan_detail);

        this.saveRolesToLocalStorage(["All"]);
        this.show_error_on_empty = false;
        this.$router.push(response.data.redirect);
        this.otp = "";
        new CripNotice({
          title: "Success",
          description: response.data.validation,
          type: "success",
          duration: 3,
        });

        this.selectUserType();

        this.$root.$emit("updatedProfileData");
       
      } else {
        this.is_vefiry_otp_btn_loading = false; //disable verify otp btn loader
        this.otp = "";
        this.show_error_on_empty = false;

        // new CripNotice({
        //     title: "Error",
        //     description: response.data.message,
        //     type: "error",
        //     duration: 3,
        // });
      }
    },

    resendOtpNetworkCallBack(response) {
      if (response.data.status) {
        this.is_resend_otp_btn_loading = false; //disable resend otp loader
        this.show_error_on_empty = false;

        localStorage.setItem("auth_email", this.email); //to validate email on otp verification page

        this.email = "";
        this.is_otp = true;
        this.is_resend_otp = false;

        new CripNotice({
          title: "Success",
          description: response.data.validation,
          type: "success",
          duration: 3,
        });
      } else {
        this.is_resend_otp_btn_loading = false; //disable resend otp loader
        this.email = "";
        this.show_error_on_empty = false;

        new CripNotice({
          title: "Error",
          description: response.data.validation,
          type: "error",
          duration: 3,
        });
      }
    },

    //set new password callback for forgot password
    setNewPasswordNetworkCallBack(response) {
      if (response.data.status) {
        this.is_set_password_btn_loading = false; //disable set password btn loader

        let body = document.getElementsByTagName("body")[0];
        body.style.overflow = "auto";
        localStorage.clear();

        this.show_error_on_empty = false;
        this.$router.push(response.data.redirect);
        this.password = "";
        // this.confirm_password = "";
        new CripNotice({
          title: "Success",
          description: response.data.validation,
          type: "success",
          duration: 3,
        });
      } else {
        this.is_set_password_btn_loading = false; //disable set password btn loader
        this.password = "";
        // this.confirm_password = "";
        this.show_error_on_empty = false;
      }
    },

    //set new password callback for forgot password
    sendOtpForForgotPasswordNetworkCallBack(response) {
      if (response.data.status) {
        // console.log(response);
        this.is_send_otp_btn_loading = false; //disable send otp btn loader
        let body = document.getElementsByTagName("body")[0];
        body.style.overflow = "auto";

        this.show_error_on_empty = false;
        localStorage.setItem("auth_email", this.email);
        this.$router.push({
          name: "verifyOtp",
          params: {
            key: "FORGET_PASSWORD",
          },
        });
        // this.$router.push(response.data.redirect);
        this.email = "";

        new CripNotice({
          title: "Success",
          description: response.data.validation,
          type: "success",
          duration: 3,
        });
      } else {
        this.is_send_otp_btn_loading = false; //disable send otp btn loader
        this.email = "";
        this.show_error_on_empty = false;
      }
    },

    logoutUserNetworkCallBack(response) {
      // if (response.data.status) {
      localStorage.clear();

      this.$root.$emit("updatedProfileData");

      if (this.$route.path == "/") {
        location.reload();
      } else {
        this.$router.push("/");
      }

      // to set state to it's initial state and clear vue store
      this.$store.commit("resetAllState");
      let body = document.getElementsByTagName("body")[0];
      body.style.overflow = "auto";

      // }
    },
  },
};
